import React from "react"

const CheckBoxWithText = ({title,onClick,value}) => {
  return (
    <div className="flexRow mt-[15px] items-start">
      <input
        type="checkbox"
        style={{
          border: "1px solid #000000",
          padding: "10px",
          borderRadius: "5px",
          marginTop: "5px",
        }}
        checked={value}
        className=""
        onClick={onClick}
      />
      <p className="font-[500] text-[14px] leading-[24px] text-greyText text-opacity-50 ml-[7px]">
        {title}
      </p>
    </div>
  )
}

export default CheckBoxWithText
